import * as React from "react";
import { useTranslation } from "react-i18next";

import { Check, Close } from "@mui/icons-material";
import { FormControl, FormControlLabel, Grid, IconButton, Radio, RadioGroup } from "@mui/material";
import axios from "axios";
import { io } from "socket.io-client";

import useSnackbarAlert from "../../../utils/snackbarHandlers";
import CommonButton from "../../common/button/Button";
import CommonInput from "../../common/input/InputBox";
import "./lottery.css";
import WinnerDialogBox from "./WinnerDialogBox";

//@ts-ignore
const config = window.config;
const currencySymbol = config.currencySymbol ?? "$";
const apiBaseURL = config?.server || "http://18.217.95.31:8080";

const LotteryListRenderer: React.FC<{}> = () => {
  const { t } = useTranslation("translation");
  const [socket, setSocket] = React.useState<any>();
  // const socket = React.useContext(SocketContext);

  // const socket = io(apiBaseURL, {
  //     autoConnect: false,
  //     query: {
  //         userId: JSON.parse(localStorage.getItem("UserData") || "")?.uId,
  //     },
  // });
  // console.log("Socket identity - ", socket);
  const rowsCount = config?.ticketRows ?? 3;
  const columnCount = config.ticketColumns ?? 6;
  const screenArray = [1, 2];

  let localData = localStorage.getItem("UserData") ?? "";
  const auth = localData ? JSON.parse(localData) : null;

  const screen = localStorage.getItem("screenNumber") ?? "";
  const screenNumberDetails = screen
    ? JSON.parse(localStorage.getItem("screenNumber") || "")
    : null;

  const settings = localStorage.getItem("settings") ?? "";
  let settingData = settings ? JSON.parse(settings) : null;
  const settingDetails = settingData?.ticketsCount > 0 ? settingData : { ticketsCount: 0 };
  //hooks
  const [windowWidth, setWindowWidth] = React.useState(window.innerWidth);

  React.useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const getEffectiveColumnCount = (width: number, settingColumnCount: number) => {
    if (width < 480) return 1;
    if (width < 768) return 2;
    if (width < 1024) return 3;
    return settingColumnCount || 6;
  };

  const [boxDimensions, setBoxDimensions] = React.useState({
    rowsCount: 0,
    columnCount: 0,
    parentBoxHeight: 0,
    parentBoxWidth: 0,
  });
  const [screenType, setScreenType] = React.useState(settingDetails?.orientation ?? "landscape");
  const [screenNumber, setScreenNumber] = React.useState(screenNumberDetails);
  const [data, setData] = React.useState<any>([]);
  const [inputs, setInputs] = React.useState(
    Array(parseInt(settingDetails?.ticketsCount)).fill(""),
  );
  const [isAnimate, setIsAnimate] = React.useState<any>(
    Array(parseInt(settingDetails?.ticketsCount)).fill(false),
  );
  const [isSoldOut, setIsSoldOut] = React.useState<any>(
    Array(parseInt(settingDetails?.ticketsCount)).fill(false),
  );
  const [isNew, setIsNew] = React.useState<any>(
    Array(parseInt(settingDetails?.ticketsCount)).fill(false),
  );
  const [isWinner, setIsWinner] = React.useState<any>(
    Array(parseInt(settingDetails?.ticketsCount)).fill(false),
  );
  const [winnerPrize, setWinnerPrize] = React.useState(
    Array(parseInt(settingDetails?.ticketsCount)).fill(""),
  );
  const { showErrorMessage, showSuccessMessage } = useSnackbarAlert();
  const [settingsVal, setSettingsVal] = React.useState(settingData);
  const [open, setOpen] = React.useState(false);
  const [winnerIndex, setWinnerIndex] = React.useState();
  const [screenOneSettings, setScreenOneSettings] = React.useState<any>();

  const handleInputChange = (index: any, value: any) => {
    const updatedInputs = [...inputs];
    updatedInputs[index] = value;
    setInputs(updatedInputs);
  };

  React.useEffect(() => {
    // socket.connect();
    setBoxDimensions({
      columnCount: 6,  // settingDetails?.column //For width of individual box
      rowsCount: settingDetails?.rows, //For height of individual box
      parentBoxHeight: 80,
      parentBoxWidth: 100,
    });

    // socket.connect();
    const establishedEvent = io(apiBaseURL, {
      autoConnect: true,
      query: {
        userId: JSON.parse(localStorage.getItem("UserData") || "")?.uId,
      },
    });
    setSocket(establishedEvent);

    return () => {
      socket && socket.disconnect();
    };
  }, []);

  const fetchLinkedTickets = (fetchedsettings: any) => {
    axios
      .get(
        `${apiBaseURL}/api/ticket/fetchShopBasedLinkedTickets?shopId=${auth?.uId}&screenNumber=${screenNumber}`,
      )
      .then((res: any) => {
        const updatedInputs: any = Array(parseInt(fetchedsettings?.ticketsCount)).fill("");
        const updatedData: any = [];
        const updatedAnimateBoxes: any = Array(parseInt(fetchedsettings?.ticketsCount)).fill(false);
        const updatedNewBoxes: any = Array(parseInt(fetchedsettings?.ticketsCount)).fill(false);
        const updatedSoldBoxes: any = Array(parseInt(fetchedsettings?.ticketsCount)).fill(false);
        const updatedWinnerBoxes: any = Array(parseInt(fetchedsettings?.ticketsCount)).fill(false);
        res?.data?.linkedTickets?.map((data: any, index: any) => {
          updatedData[data?.ticketPosition] = data;
          updatedInputs[data?.ticketPosition] = data?.ticketNumber;
          updatedAnimateBoxes[data?.ticketPosition] = data?.isAnimate;
          updatedSoldBoxes[data?.ticketPosition] = data?.isSoldOut;
          updatedNewBoxes[data?.ticketPosition] = data?.isNew;
          updatedWinnerBoxes[data?.ticketPosition] = data?.isWinner;
        });
        setInputs(updatedInputs);
        setData(updatedData);
        setIsAnimate(updatedAnimateBoxes);
        setIsSoldOut(updatedSoldBoxes);
        setIsNew(updatedNewBoxes);
        setIsWinner(updatedWinnerBoxes);
      })
      .catch((error: Error) => {
        console.log("err", error);
      });
  };

  React.useEffect(() => {
    let fetchedsettings: any;
    axios
      .get(`${apiBaseURL}/api/settings/fetchSettings?id=${auth?.uId}&screenNumber=${screenNumber}`)
      .then((data: any) => {
        if (data?.status == 200) {
          let settingsDetail = data?.data?.settings;
          fetchedsettings = {
            settingId: settingsDetail?.id,
            screenNumber: settingsDetail?.screenNumber,
            headerFooterStyle: settingsDetail?.headerFooterStyle,
            ticketsCount: settingsDetail?.ticketsCount,
            rows: settingsDetail?.rows,
            column: 6, //settingsDetail?.column
            emptyTicketsDisplay: settingsDetail?.emptyTicketsDisplay,
            backgroundType: settingsDetail?.backgroundType,
            backgroundValue: settingsDetail?.backgroundValue,
            orientation: settingsDetail?.orientation,
          };

          if (data?.data?.screenOneSettings) {
            let localScreenOneSettings = {
              ticketsCount: data?.data?.screenOneSettings?.ticketsCount,
            };

            setScreenOneSettings(localScreenOneSettings);
            localStorage.setItem("screenOneSettings", JSON.stringify(localScreenOneSettings));
          }

          setScreenType(settingsDetail?.orientation ?? "landscape");

          localStorage.setItem("settings", JSON.stringify(fetchedsettings));
          setSettingsVal(fetchedsettings);
        }
      })
      .catch((err: any) => {
        console.log("err", err);
      })
      .finally(() => {
        fetchLinkedTickets(fetchedsettings);
      });
  }, [screenNumber]);

  const addTicket = (ticketNumber: any, index: any) => {
    socket.emit("fetchParticularTicketDetailByNumber", {
      ticketNumber: ticketNumber,
      shopId: auth?.uId,
      screenNumber: screenNumber,
      ticketPosition: index,
    });
  };

  const deleteTicket = (index: any) => {
    socket.emit("deleteLinkedTicket", {
      id: data[index]?.linkedId,
      userId: auth?.uId,
      ticketPosition: index,
      screenNumber: screenNumber,
    });

    const updatedAnimateBoxes = [...isAnimate];
    const updatedSoldBoxes = [...isSoldOut];
    const updatedNewBoxes = [...isNew];
    const updatedWinnerBoxes = [...isWinner];
    updatedAnimateBoxes[index] = false;
    updatedSoldBoxes[index] = false;
    updatedNewBoxes[index] = false;
    updatedWinnerBoxes[index] = false;

    setIsAnimate(updatedAnimateBoxes);
    setIsSoldOut(updatedSoldBoxes);
    setIsNew(updatedNewBoxes);
    setIsWinner(updatedWinnerBoxes);

  };

  const updateOrientation = (orientationType: any) => {
    socket.emit("updateScreenOrientation", {
      shopId: auth?.uId,
      screenNumber: screenNumber,
      orientation: orientationType,
    });
  };

  React.useEffect(() => {
    socket &&
      socket.on("fetchTicketByNumberResponse", (response: any) => {
        if (response?.message || response?.error) {
          return showErrorMessage(response?.error ?? response?.message);
        } else {
          const updatedData = [...data];
          updatedData[response.ticketPosition] = {
            ...response.ticket,
            ...{ linkedId: response?.linkedId, screenNumber: response?.screenNumber },
          };
          setData(updatedData);
          handleInputChange(response.ticketPosition, response.ticket?.ticketNumber);
          return showSuccessMessage(t("addLinkedTicketSuccessMsg", "Ticket added successfully"));
        }
      });

    socket &&
      socket.on("deleteLinkedTicketResponse", (response: any) => {
        const updatedData = [...data];

        handleInputChange(response.ticketPosition, "");
        updatedData[response.ticketPosition] = {};
        setData(updatedData);
        return showSuccessMessage(response?.message);
      });

    socket &&
      socket.on("updateLinkedTicketResponse", (response: any) => {
        console.log("res", response);
        return showSuccessMessage(response?.message);
      });

    socket &&
      socket.on("updateScreenOrientationResponse", (response: any) => {
        console.log("updateScreenOrientationResponse - ", response);
        if (response?.orientation) {
          setScreenType(response?.orientation ?? "landscape");
        }
        return showSuccessMessage(response?.message);
      });

    return () => {
      socket && socket.off("fetchTicketByNumberResponse");
      socket && socket.off("deleteLinkedTicketResponse");
      socket && socket.off("updateLinkedTicketResponse");
      socket && socket.off("updateScreenOrientationResponse");
    };
  }, [socket, data]);

  const handleCheck = (index: any, ticketNumber: any, checkName: any, event: any) => {
    const updatedAnimatedBoxes = [...isAnimate];
    const updatedSoldOutBoxes = [...isSoldOut];
    const updatedNewBoxes = [...isNew];

    if (checkName === "animate") {
      updatedAnimatedBoxes[index] = event.target.checked;
      setIsAnimate(updatedAnimatedBoxes);
    }
    if (checkName === "new") {
      updatedNewBoxes[index] = event.target.checked;
      setIsNew(updatedNewBoxes);
    }
    if (checkName === "soldOut") {
      updatedSoldOutBoxes[index] = event.target.checked;
      setIsSoldOut(updatedSoldOutBoxes);
    }

    const paramsData = {
      ticketNumber: ticketNumber,
      userId: auth?.uId,
      ticketPosition: index,
      screenNumber: screenNumber
    };

    socket.emit("updateLinkedTicket", paramsData, {
      isAnimate: updatedAnimatedBoxes[index],
      isNew: updatedNewBoxes[index],
      isSoldOut: updatedSoldOutBoxes[index],
    });

    // return () => {
    //     socket.disconnect();
    // }
  };

  const handleWinnerCheck = (index: any, event: any) => {
    setWinnerIndex(index);
    const updatedWinnerBoxes = [...isWinner];
    updatedWinnerBoxes[index] = event.target.checked;
    setIsWinner(updatedWinnerBoxes);
    event.target.checked && setOpen(true);
    const paramsData = {
      ticketNumber: data[index]?.linkedId,
      userId: auth?.uId,
      ticketPosition: index,
      screenNumber: screenNumber
    };
    event.target.checked == false &&
      socket.emit("updateLinkedTicket", paramsData, {
        isWinner: event.target.checked,
      });
  };
  const handleWinnderUpdate = (index: any) => {
    const paramsData = {
      ticketNumber: data[index]?.linkedId,
      userId: auth?.uId,
      ticketPosition: index,
      screenNumber: screenNumber
    };
    socket.emit("updateLinkedTicket", paramsData, {
      isWinner: isWinner[index],
      prizeMoney: winnerPrize[index] ?? 0,
    });
    setOpen(false);
  };

  const effectiveColumnCount = getEffectiveColumnCount(windowWidth, boxDimensions?.columnCount);

  return (
    <Grid className="position-relative font-['Baloo_2']">
      <Grid className='front-cards'>
        <div className='lottery-list-screen-buttons'>
          {screenArray.map((item, index) => {
            return (
              <CommonButton
                key={index}
                id='login-button'
                className={item == screenNumber ? "settings-screen-selected-button" : "settings-screen-button"}
                variant={index == screenNumber ? "outlined" : "contained"}
                onClick={() => {
                  setScreenNumber(index + 1);
                }}
                ignoreButtonRootClass={true}
              >
                {t("screen", { screenCount: index + 1 })}
              </CommonButton>
            );
          })}
        </div>
        <Grid className='p-4'>
          <FormControl>
            <Grid className='text-[1.25rem] font-[600]'>{t("screenOrientation")}</Grid>
            <RadioGroup
              aria-labelledby='demo-controlled-radio-buttons-group'
              name='controlled-radio-buttons-group'
              value={screenType}
              onChange={(event: any) => updateOrientation((event.target as HTMLInputElement).value)}
            >
              <FormControlLabel value='landscape' control={<Radio />} label={t("landscape")} />
              <FormControlLabel value='portrait' control={<Radio />} label={t("portrait")} />
            </RadioGroup>
          </FormControl>
        </Grid>
        <Grid className='w-full'>
          <Grid
            className='parent-box-container'
            style={{
              width: `${boxDimensions?.parentBoxWidth - 10}%`,
            }}
          >
            {inputs?.slice(0, parseInt(settingsVal?.ticketsCount)).map((item, index) => {
              return (
                <Grid
                  className={`shop-lottery-box position-relative bg-[#ddd]`}
                  style={{
                    width: `${boxDimensions?.parentBoxWidth / effectiveColumnCount - 1}%`,
                  }}
                  key={index}
                >
                  <Grid className='text-center font-bold'>{screenOneSettings?.ticketsCount ? (screenOneSettings?.ticketsCount + index + 1) : (index + 1)}</Grid>
                  <Grid
                    className={`position-relative flex justify-center items-center ticket-image-container`}
                    key={index}
                    style={{
                      backgroundImage: `url(${data[index]?.imageUrl})`,
                      backgroundSize: "100% 100%",
                      backgroundRepeat: "no-repeat",
                      border: "2px solid black",
                    }}
                  >
                    <div className='shop-ribbon shop-ribbon-top-left'>
                      <span>
                        {data[index]?.ticketPrice
                          ? currencySymbol + data[index]?.ticketPrice
                          : null}
                      </span>
                    </div>
                  </Grid>
                  <Grid
                    container
                    className='ticket-input-row'
                  >
                    <Grid item xs={7} style={{ margin: "8px 4% 0px 3%" }}>
                      <CommonInput
                        key={index}
                        id={`ticket-number-input-box`}
                        fullWidth
                        className='white-input-box'
                        name={`ticketNumber+${index}`}
                        value={item}
                        placeholder={t("ticket")}
                        onChange={(e) => handleInputChange(index, e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={2} style={{ margin: "10px 1% 0px 0%" }}>
                      <IconButton
                        key={index}
                        color='success'
                        className='custom-ticket-button'
                        disabled={inputs[index] === ""}
                        onClick={() => addTicket(inputs[index], index)}
                      >
                        <Check style={{ color: "white" }} />
                      </IconButton>
                    </Grid>
                    <Grid item xs={2} style={{ margin: "10px 0% 0px 0%" }}>
                      <IconButton
                        color='error'
                        className='custom-ticket-button custom-red-background'
                        disabled={inputs[index] === ""}
                        onClick={() => deleteTicket(index)}
                      >
                        <Close style={{ color: "white" }} />
                      </IconButton>
                    </Grid>
                  </Grid>
                  {data[index]?.ticketNumber && (
                    <Grid
                      container
                      className='ticket-checkbox-row'
                    >
                      <Grid item xs={12} sm={12} md={12} lg={12} style={{ margin: "0% 0% 0% 3%" }}>
                        <Grid container style={{ width: "100%", height: "100%" }}>
                          <Grid item xs={2}>
                            <input
                              type='checkbox'
                              id='animate'
                              name='animate'
                              value='animate'
                              checked={isAnimate[index]}
                              onChange={(event) =>
                                handleCheck(index, data[index]?.linkedId, "animate", event)
                              }
                            />
                          </Grid>
                          <Grid item xs={8}>
                            <label style={{ fontSize: "18px" }}>{t("animate")}</label>{" "}
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item xs={12} sm={12} md={12} lg={12} style={{ margin: "0% 0% 0% 3%" }}>
                        <Grid container style={{ width: "100%", height: "100%" }}>
                          <Grid item xs={2}>
                            <input
                              type='checkbox'
                              id='new'
                              name='new'
                              value='new'
                              checked={isNew[index]}
                              onChange={(event) =>
                                handleCheck(index, data[index]?.linkedId, "new", event)
                              }
                            />{" "}
                          </Grid>
                          <Grid item xs={7}>
                            <label style={{ fontSize: "18px" }}>{t("new")}</label>{" "}
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item xs={12} sm={12} md={12} lg={12} style={{ margin: "0% 0% 0% 3%" }}>
                        <Grid container style={{ width: "100%", height: "100%" }}>
                          <Grid item xs={2}>
                            <input
                              type='checkbox'
                              id='soldOut'
                              name='soldOut'
                              value='soldOut'
                              checked={isSoldOut[index]}
                              onChange={(event) =>
                                handleCheck(index, data[index]?.linkedId, "soldOut", event)
                              }
                            />
                          </Grid>
                          <Grid item xs={9}>
                            <label style={{ fontSize: "18px" }}>{t("soldOut")}</label>{" "}
                          </Grid>
                        </Grid>
                      </Grid>
                      {/* <Grid item xs={12} sm={12} md={12} lg={12} style={{ margin: "0% 0% 0% 3%" }}>
                        <Grid container style={{ width: "100%", height: "100%" }}>
                          <Grid item xs={2} className='w-full'>
                            <input
                              type='checkbox'
                              id='winner'
                              name='winner'
                              value='winner'
                              checked={isWinner[index]}
                              onChange={(event) => handleWinnerCheck(index, event)}
                            />
                          </Grid>
                          <Grid item xs={9}>
                            <label style={{ fontSize: "18px" }}>{t("winner")}</label>{" "}
                          </Grid>
                        </Grid>
                      </Grid> */}
                    </Grid>
                  )}
                </Grid>
              );
            })}
          </Grid>
        </Grid>
      </Grid>
      <WinnerDialogBox
        open={open}
        setOpen={setOpen}
        handleWinnderUpdate={handleWinnderUpdate}
        index={winnerIndex}
        winnerPrize={winnerPrize}
        setWinnerPrize={setWinnerPrize}
      />
    </Grid>
  );
};
export default LotteryListRenderer;
